import { useTranslation } from 'react-i18next';
import { E2NTableCell } from '../../../../components/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getTimeDisplayFromDate } from '../../../../utils';
import { Badge } from '@e2n/ui';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';

export function DienstplanuebernahmeArbeitszeit({
  beginn,
  ende,
  dauer,
}: {
  beginn: Date;
  ende?: Date;
  dauer: number;
}) {
  const { t } = useTranslation();

  return (
    <E2NTableCell className="font-semibold w-[30%]" isBorderVisible>
      <div className="flex items-center justify-between gap-4">
        <Badge className="flex flex-col gap-1 items-start basis-auto bg-primary-blue-100 hover:bg-primary-blue-100 text-primary-blue-600 text-sm font-semibold shadow-none">
          {beginn !== null ? (
            <span>{getTimeDisplayFromDate(beginn)}</span>
          ) : (
            <FontAwesomeIcon icon={faQuestionCircle} size="lg" />
          )}
        </Badge>
        {dauer !== 0 ? (
          <>
            <div className="h-px  bg-neutrals-500 grow" />
            <span className="text-xs  text-neutrals-700">
              {dauer} {t('general.date.minutes')}
            </span>
            <div className="h-px bg-neutrals-500 grow" />
          </>
        ) : (
          <div className="h-px bg-neutrals-500 grow" />
        )}

        <Badge
          className={`flex flex-col gap-1 items-start justify-center shadow-none ${
            ende !== null ? 'basis-auto' : 'basis-[30px] h-[30px]'
          } bg-primary-blue-100 hover:bg-primary-blue-100 text-primary-blue-600 text-sm font-semibold`}>
          {ende !== null ? (
            <span>{getTimeDisplayFromDate(ende)}</span>
          ) : (
            <FontAwesomeIcon icon={faQuestionCircle} size="lg" />
          )}
        </Badge>
      </div>
    </E2NTableCell>
  );
}
